// extracted by mini-css-extract-plugin
export var close = "ExitModal-module--close--Cq0Pn";
export var container = "ExitModal-module--container--r-Cbb";
export var imgContainer = "ExitModal-module--imgContainer--Hy1++";